// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Facebook, Instagram, Phone } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-col-1">
          <img src="/images/logo.png" alt="Logo de la empresa" className="footer-logo" />
          <p className="footer-slogan">Calidad y placer a la hora de comer.</p>
        </div>

        <div className="footer-col-2">
          <h4>Navegación</h4>
          <nav className="footer-nav">
            <NavLink to="/">Inicio</NavLink>
            <NavLink to="/catalogo">Catálogo</NavLink>
            <NavLink to="/domicilio">Domicilios</NavLink>
            <NavLink to="/contacto">Contacto</NavLink>
          </nav>
        </div>

        <div className="footer-col-3">
          <h4>Contacto</h4>
          <p><Phone size={16} /> WhatsApp:</p>
          <div className="whatsapp-links">
            <a href="https://wa.me/573043882058">304 388 2058</a> | <a href="https://wa.me/573122752011">312 272 5211</a>
          </div>
          <p>Dirección: Cl. 54A #81B - 86, Calasanz Ferrini, Medellín, Antioquia</p>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><Facebook /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><Instagram /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom-bar">
        <p>© {currentYear} Palomanía. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;